<div class="flex no-video">
    @if (failed) {
        <div class="error-state flex column justify-center align-items-center">
            <mat-icon color="warn" class="error-icon">error</mat-icon>
            <h2>Processing failed</h2>
            @if (assetName) {
                <p>
                    "{{ assetName }}" could not be processed@if (uploaderName) { (uploaded by {{ uploaderName }})}.
                </p>
            } @else {
                <p>This video could not be processed.</p>
            }
        </div>
    } @else {
        <div class="glitch">
            <h1>Video is still processing</h1>
            <h1>Video is still processing</h1>
            <h1>Video is still processing</h1>
            <h1>Video is still processing</h1>
            <h1>Video is still processing</h1>
            <h1>Video is still processing</h1>
            <h1>Video is still processing</h1>
        </div>
        @if (assetName || uploaderName) {
            <p>
                @if (assetName) {"{{ assetName }}" }@if (uploaderName) {— uploaded by {{ uploaderName }}}
            </p>
        } @else {
            <p>Please wait while it finishes encoding</p>
        }
    }
</div>
